// Module
var code = "<h2 id=\"executive-team\">Executive Team</h2> <p>Learn more about PHEAA&#39;s senior leadership team, such as their roles and responsibilities. </p> ";
// Exports
export default code;